import { Component, OnInit } from '@angular/core';
import { PdfService } from '../service/pdf.service';
import { ModalService } from '../service/device-modal.service';
import { IotService } from '../service/iot.service';
import { CognitoService } from '../service/cognito.service';
import { environment } from '../environments/environment';
import { ThemeService } from '../service/theme.service';

@Component({
  selector: 'app-iot-modular',
  templateUrl: './iot-modular.component.html',
  styleUrls: ['./iot-modular.component.css'],
  standalone: false,
})
export class IotModularComponent implements OnInit {
  mainContent: string = 'devices';
  private readonly tabStorageKey = 'iot.activeTab';
  private readonly allowedTabs = new Set([
    'devices',
    'technical',
    'reports',
    'feed',
    'devices-location',
  ]);

  constructor(
    public pdf: PdfService,
    public modal: ModalService,
    public iotService: IotService,
    public cognitoService: CognitoService,
    public theme: ThemeService,
  ) {
    // Role check
    this.cognitoService.getCurrentRole(
      [environment.users.role.administrator],
      [environment.users.superAdmin],
    );
  }

  ngOnInit(): void {
    const stored = this.getStoredTab();
    if (stored) {
      this.mainContent = stored;
    }
  }

  devicesClicked(): void {
    this.setActiveTab('devices');
  }
  technicalClicked(): void {
    this.setActiveTab('technical');
  }
  reportsClicked(): void {
    this.setActiveTab('reports');
  }
  shadowFeedClicked(): void {
    this.setActiveTab('feed');
  }
  devicesLocationClicked(): void {
    this.setActiveTab('devices-location');
  }

  onDeviceGroupChange(event: { newGroup: string }): void {
    // placeholder hook for device group change from config modal
  }

  private setActiveTab(tab: string): void {
    if (!this.allowedTabs.has(tab)) {
      return;
    }
    this.mainContent = tab;
    this.storeTab(tab);
  }

  private storeTab(tab: string): void {
    try {
      localStorage.setItem(this.tabStorageKey, tab);
    } catch {
      // Storage might be unavailable; ignore.
    }
  }

  private getStoredTab(): string | null {
    try {
      const stored = localStorage.getItem(this.tabStorageKey);
      return stored && this.allowedTabs.has(stored) ? stored : null;
    } catch {
      return null;
    }
  }
}
